import { EventTypeInfo } from './event_type_info'
import { InfoBanner } from './info_banner'
import { TabContainer } from './styles'
import {
  InviteesWidget,
  BestTimesWidget,
  LocationsWidget,
  TimeOptionsWidget,
  UtmParamsWidget,
  HostsWidget,
  PaymentWidget,
  InstructionsWidget,
  QuestionsWidget,
  TimelineWidget,
  MeetingPackageWidget
} from './widgets'
import { isPendingEvent } from '../utils'


export const DetailsTab = ({ selectedEvent }) => {
  const isPending = isPendingEvent(selectedEvent)
  const isPoll = selectedEvent.bookingMethod === 'poll'

  return (
    <TabContainer>
      <InfoBanner event={selectedEvent} />
      {!isPending && <InviteesWidget event={selectedEvent} />}
      {!isPending && <QuestionsWidget event={selectedEvent} />}
      {isPending && !isPoll && <TimeOptionsWidget event={selectedEvent} />}
      {isPending && isPoll && <BestTimesWidget event={selectedEvent} />}
      <LocationsWidget event={selectedEvent} />
      <UtmParamsWidget event={selectedEvent} />
      {isPending && <InstructionsWidget event={selectedEvent} />}
      <HostsWidget event={selectedEvent} />
      <PaymentWidget event={selectedEvent} />
      {!isPending && <TimelineWidget event={selectedEvent} />}
      <MeetingPackageWidget event={selectedEvent} />
      <EventTypeInfo event={selectedEvent} />
    </TabContainer>
  )
}
